export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
                name: 'Div',
                attributes: { class: 'd-flex gap-16 wrap margin-top-50' },
                components: [
                    {
                        type: 'itemProducts3',
                    },
                    {
                        type: 'itemProducts3',
                    },
                    {
                        type: 'itemProducts3',
                    },
                    {
                        type: 'itemProducts3',
                    },

                ],
                styles: `
                .gap-16{
                    gap: 16px; 
                }
                .margin-top-16{
                    margin-top: 16px;
                }
                .d-flex{
                    display: flex;
                }
                .margin-top-50{
                    margin-top: 50px;
                }
                .wrap{
                    flex-wrap: wrap;
                }
            `,
            },
        },
        view: {

        },
    };
    return component;
};